/* eslint-disable react-hooks/exhaustive-deps */
import { Layout } from 'layouts/Layout'
import { GroundingStepper } from 'modules/Grounding/GroundingStepper'
import GroundingOptions from 'modules/Grounding/GroundingOptions'
import GroundingResult from 'modules/Grounding/GroundingResult'
import GroundingTurnIn from 'modules/Grounding/GroundingTurnIn'
import { GroundingWithVIN } from 'modules/Grounding/GroundingWithVIN'
import { GroundingRenderStep } from 'modules/Grounding/store/RenderStep'
import { useGroundingStore } from 'modules/Grounding/store/useGroundingStore'
import shallow from 'zustand/shallow'
import { GroundingContainer, StyledHeaderContainer } from './Grounding.styled'
import { useEffect, useState } from 'react'
import TermsModal from 'components/Grounding/TermsModal'
import { useGlobalStore } from 'store/useGlobalStore'
import { Return_To_Dashboard, SessionStorageKey } from 'common/constants'
import GroundingConfirmModal from 'components/Grounding/GroundingConfirmModal'
import { useHistory } from 'react-router-dom'
import { GroundingStep, useGroundingActionStore } from 'modules/Grounding/store/useGroundingActionStore'

export const Grounding = () => {
  const [showTerms, setShowTerms] = useGroundingStore(
    (state) => [
      state.showTerms,
      state.setShowTerms,
      state.setAlreadyConfirmRecall,
      state.setAlreadyConfirmGeneralModal
    ],
    shallow
  )
  const [activeStep, setActiveStep, setGroundingStepInfor, isBack, setIsBack, setIsSubmit] = useGroundingActionStore(
    (state) => [
      state.activeStep,
      state.setActiveStep,
      state.setGroundingStepInfor,
      state.isBack,
      state.setIsBack,
      state.setIsSubmit
    ],
    shallow
  )

  const [showGroundingCancelModal, setShowGroundingCancelModal] = useState(false)
  const [showBackToEnterVinModal, setShowBackToEnterVinModal] = useState(false)

  const { getLocalText } = useGlobalStore((state) => state)
  const history = useHistory()
  const returnToDashboardText = getLocalText(
    Return_To_Dashboard,
    'Are you sure you want to navigate away from this page? By leaving this window you will lose any changes you have made. Press OK to continue, or cancel to stay on the current page.'
  )
  const StepInit = [
    {
      label: 'ENTER VIN',
      stepIndex: GroundingRenderStep.GRD_ENTER_VIN,
      active: true,
      completed: false,
      disabled: false
    },
    {
      label: 'GROUNDING OPTIONS',
      stepIndex: GroundingRenderStep.GRD_OPTIONS,
      active: false,
      completed: false,
      disabled: true
    },
    {
      label: 'TURN IN',
      stepIndex: GroundingRenderStep.GRD_TURN_IN,
      active: false,
      completed: false,
      disabled: true
    },
    {
      label: 'RESULT',
      stepIndex: GroundingRenderStep.GRD_RESULT,
      active: false,
      completed: false,
      disabled: true
    }
  ] as GroundingStep[]

  useEffect(() => {
    setGroundingStepInfor(StepInit)
  }, [])

  useEffect(() => {
    let steps = [...StepInit]
    switch (activeStep) {
      case GroundingRenderStep.GRD_ENTER_VIN:
        setIsBack(false)
        break
      case GroundingRenderStep.GRD_OPTIONS:
        steps[GroundingRenderStep.GRD_ENTER_VIN].active = false
        steps[GroundingRenderStep.GRD_ENTER_VIN].completed = true
        steps[GroundingRenderStep.GRD_ENTER_VIN].disabled = false
        steps[activeStep].active = true
        steps[activeStep].disabled = false
        steps[activeStep].completed = false
        if (isBack) {
          steps[GroundingRenderStep.GRD_TURN_IN].completed = true
          steps[GroundingRenderStep.GRD_TURN_IN].disabled = false
        }
        break
      case GroundingRenderStep.GRD_TURN_IN:
        for (let i = 0; i < activeStep; i++) {
          steps[i].active = false
          steps[i].completed = true
          steps[i].disabled = false
        }
        steps[activeStep].active = true
        steps[activeStep].disabled = false
        steps[activeStep].completed = false
        break
      case GroundingRenderStep.GRD_RESULT:
        for (let i = 0; i < activeStep; i++) {
          steps[i].active = false
          steps[i].completed = true
          steps[i].disabled = true
        }
        steps[activeStep].active = true
        steps[activeStep].disabled = false
        steps[activeStep].completed = false
        break
      default:
        break
    }
    setGroundingStepInfor(steps)
  }, [activeStep])

  const handelStepperOnClick = (stepIndex: number) => {
    if (
      stepIndex === GroundingRenderStep.GRD_ENTER_VIN &&
      activeStep !== GroundingRenderStep.GRD_RESULT &&
      activeStep !== GroundingRenderStep.GRD_ENTER_VIN
    ) {
      setShowBackToEnterVinModal(true)
    } else {
      if (stepIndex === GroundingRenderStep.GRD_TURN_IN) {
        setIsSubmit(true)
        return
      }

      stepIndex < activeStep ? setIsBack(true) : setIsBack(false)
      setIsSubmit(false)
      setActiveStep(stepIndex)
    }
  }

  const handleAcknowledgedConfirm = () => {
    setShowBackToEnterVinModal(false)
    setActiveStep(GroundingRenderStep.GRD_ENTER_VIN)
  }

  return (
    <Layout title="Grounding">
      <GroundingContainer>
        <StyledHeaderContainer>
          <h3>GROUND A VEHICLE</h3>
          <GroundingStepper
            onClick={(stepIndex) => {
              handelStepperOnClick(stepIndex)
            }}
          />
        </StyledHeaderContainer>
        <div>
          {activeStep === GroundingRenderStep.GRD_ENTER_VIN && <GroundingWithVIN />}
          {activeStep === GroundingRenderStep.GRD_OPTIONS && (
            <GroundingOptions setShowCancelModal={setShowGroundingCancelModal} />
          )}
          {activeStep === GroundingRenderStep.GRD_TURN_IN && (
            <GroundingTurnIn setShowCancelModal={setShowGroundingCancelModal} />
          )}
          {activeStep === GroundingRenderStep.GRD_RESULT && <GroundingResult />}
        </div>
        {showTerms && <TermsModal show={showTerms} setShowTerms={setShowTerms}></TermsModal>}
      </GroundingContainer>
      {showGroundingCancelModal && (
        <GroundingConfirmModal
          content={returnToDashboardText}
          show={showGroundingCancelModal}
          events={{
            onClose: () => {
              setShowGroundingCancelModal(false)
            },
            setShowModal: setShowGroundingCancelModal,
            handleAcknowledgedConfirm: () => {
              setShowGroundingCancelModal(false)
              setActiveStep(GroundingRenderStep.GRD_ENTER_VIN)
              sessionStorage.setItem(SessionStorageKey.GROUND_VIN, '')
              history.push('/')
            },
            handleClickXButton: () => {
              setShowGroundingCancelModal(false)
            }
          }}
          isShowHeader={false}
          isShowButton={true}
          isShowYesButton={false}
          isShowNoButton={false}
          isBackdropStatic={false}
        ></GroundingConfirmModal>
      )}
      {showBackToEnterVinModal && (
        <GroundingConfirmModal
          content={returnToDashboardText}
          show={showBackToEnterVinModal}
          events={{
            onClose: () => {
              setShowBackToEnterVinModal(false)
            },
            setShowModal: setShowBackToEnterVinModal,
            handleAcknowledgedConfirm: handleAcknowledgedConfirm,
            handleClickXButton: () => {
              setShowBackToEnterVinModal(false)
            }
          }}
          isShowHeader={false}
          isShowButton={true}
          isShowYesButton={false}
          isShowNoButton={false}
          isBackdropStatic={false}
        ></GroundingConfirmModal>
      )}
    </Layout>
  )
}
